import { useEffect, useState } from 'react';
import { fetchTownNews } from '../api/town-news.api';
import type { TownNewsSnapshot } from '../types/town-news.types';

export function useTownNews(npcId: number) {
  const [requestVersion, setRequestVersion] = useState(0);
  const [state, setState] = useState<{npcId: number; snapshot: TownNewsSnapshot | null; failed: boolean}>({npcId, snapshot: null, failed: false});
  useEffect(() => {
    let active = true;
    const request = new AbortController();
    setState({npcId, snapshot: null, failed: false});
    void fetchTownNews(npcId, request.signal).then(snapshot => {
      if (active) setState({npcId, snapshot, failed: false});
    }).catch(() => {
      if (active && !request.signal.aborted) setState({npcId, snapshot: null, failed: true});
    });
    return () => { active = false; request.abort(); };
  }, [npcId, requestVersion]);
  const visible = state.npcId === npcId ? state : {npcId, snapshot: null, failed: false};
  return { ...visible, retry: () => setRequestVersion(version => version + 1) };
}
